import type { IconSvgObject } from './types';

const MouseRightIcon: IconSvgObject = [
  ["path", { d: "M11.2422 8.5V5.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12.2422 2.0449C11.9236 2.0152 11.5905 2 11.2422 2C5.24219 2 3.74219 6.50998 3.74219 12C3.74219 17.49 5.24219 22 11.2422 22C17.2423 22 18.7422 17.49 18.7422 12C18.7422 11.3158 18.7189 10.6469 18.6665 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.2422 4C16.2422 5.10457 17.1376 6 18.2422 6C19.3468 6 20.2422 5.10457 20.2422 4C20.2422 2.89543 19.3468 2 18.2422 2C17.1376 2 16.2422 2.89543 16.2422 4Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default MouseRightIcon;
